import createReducer from "../../reducers/createReducer";
import {
  ONBOARD_EMPLOYEE_INFO_LOADING,
  ONBOARD_EMPLOYEE_INFO_SUCCESS,
  ONBOARD_EMPLOYEE_INFO_ERROR,
  ONBOARD_EMPLOYEE_VERIFY_LOADING,
  ONBOARD_EMPLOYEE_VERIFY_SUCCESS,
  ONBOARD_EMPLOYEE_VERIFY_ERROR,
  DEDUCTION_LIST_LOADING,
  DEDUCTION_LIST_SUCCESS,
  DEDUCTION_LIST_ERROR,
  ONBOARD_EMPLOYEE_VERIFY_GOVT_ERROR,
  ONBOARD_EMPLOYEE_VERIFY_GOVT_LOADING,
  ONBOARD_EMPLOYEE_VERIFY_GOVT_SUCCESS,
  ONBOARD_EMPLOYEE_TERMS_LOADING,
  ONBOARD_EMPLOYEE_TERMS_SUCCESS,
  ONBOARD_EMPLOYEE_TERMS_ERROR
} from "./types";

let initialState = {
  loading: false,
  error: null,
  onBoardEmploeeinfo: null,
  success: null,
  termsSuccess: null,
  termsError: null,
  deductionList: [],
  verifyEmployeeGovtData: {
    isLoading: false,
    success: {
      nin: "",
      bvn: "",
      nin_validated: false,
      bvn_validated: false
    },
    error: null
  }
};

export const employeeRegistrationReducer = createReducer(initialState, {
  [ONBOARD_EMPLOYEE_VERIFY_GOVT_LOADING](state, action) {
    return Object.assign({}, state, {
      verifyEmployeeGovtData: {
        isLoading: true,
        success: {
          ...state.verifyEmployeeGovtData.success,
          nin_validated: state.verifyEmployeeGovtData.success.nin_validated,
          bvn_validated: state.verifyEmployeeGovtData.success.bvn_validated,
        },
        error: null
      }
    });
  },
  [ONBOARD_EMPLOYEE_VERIFY_GOVT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      verifyEmployeeGovtData: {
        isLoading: false,
        success: {
          ...state.verifyEmployeeGovtData.success,
          ...action.payload,
          nin_validated: action.payload.nin_validated !== undefined ? action.payload.nin_validated : state.verifyEmployeeGovtData.success.nin_validated,
          bvn_validated: action.payload.bvn_validated !== undefined ? action.payload.bvn_validated : state.verifyEmployeeGovtData.success.bvn_validated,
        },
        error: null
      }
    });
  },
  [ONBOARD_EMPLOYEE_VERIFY_GOVT_ERROR](state, action) {
    return Object.assign({}, state, {
      verifyEmployeeGovtData: {
        isLoading: false,
        error: action.payload
      }
    });
  },
  [ONBOARD_EMPLOYEE_INFO_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      onBoardEmploeeinfo: null,
      success: null,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEE_INFO_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardEmploeeinfo: action.payload,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEE_INFO_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardEmploeeinfo: null,
      error: action.payload,
    });
  },
  [ONBOARD_EMPLOYEE_VERIFY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEE_VERIFY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [ONBOARD_EMPLOYEE_VERIFY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [ONBOARD_EMPLOYEE_TERMS_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      termsSuccess: null,
      termsError: null,
    });
  },
  [ONBOARD_EMPLOYEE_TERMS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      termsSuccess: action.payload,
      termsError: null,
    });
  },
  [ONBOARD_EMPLOYEE_TERMS_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      termsSuccess: null,
      termsError: action.payload,
      error: action.payload,
    });
  },
  [DEDUCTION_LIST_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      deductionList: [],
      error: null,
    });
  },
  [DEDUCTION_LIST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deductionList: action.payload,
      error: null,
    });
  },
  [DEDUCTION_LIST_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      deductionList: [],
      error: action.payload,
    });
  },
});
